import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/product-category";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (value) => {
    return await axiosInstance(options).get(`${path}/details?_id=${value}`);
}

export const Add = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const Status = async (values) => {
    return await axiosInstance(options).patch(`${path}/change-status`, values);
};

export const Delete = async (values) => {
  console.log(values)
  return await axiosInstance(options).delete(`${path}/delete?_id=${values._id}`, values)
}

export const Edit = async (values) => {
    return await axiosInstance(options).post(`${path}/edit`, values);
}

export const Reorder = async (values) => {
    return await axiosInstance(options).put(`${path}/reorder`, values);
}

const groupingPath = "admin/product-grouping";

export const GroupingList = async (values) => {
  return await axiosInstance(options).post(`${groupingPath}/list`, values);
};

export const GroupingDetails = async (value) => {
    return await axiosInstance(options).get(`${groupingPath}/details?_id=${value._id}`);
}

export const AddGrouping = async (values) => {
  return await axiosInstance(options).post(`${groupingPath}/add`, values);
};

export const GroupingStatus = async (values) => {
    return await axiosInstance(options).patch(`${groupingPath}/change-status`, values);
};

export const GroupingDelete = async (values) => {
  return await axiosInstance(options).delete(`${groupingPath}/delete?_id=${values._id}`, values)
}

export const EditGrouping = async (values) => {
    return await axiosInstance(options).post(`${groupingPath}/edit`, values);
}

export const GroupingReorder = async (values) => {
    return await axiosInstance(options).put(`${groupingPath}/reorder`, values);
}
